module.exports = PROPERTIES_CONFIG;